import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import styles from "./switch-button.module.scss";
import classnames from "classnames";

export class SwitchProps extends BaseProps {
  onClick: Function;
}

export const SwitchButton = (({
                                controller,
                                className,
                                activeButtonClassName,
                                label,
                                isActive,
                                onClick
                              }: SwitchProps) => {

  const containerProps = {
    className: classnames(className, styles.container, {[styles.label_included]: !!label}),
    onClick: () => {
      onClick && onClick(!isActive);
    }
  }

  const activeToggleClassName = classnames(styles.active_toggle, activeButtonClassName);

  const buttonProps = {
    className: classnames(
      styles.toggle,
      {[activeToggleClassName]: isActive},
      {[styles.active_ltr_toggle]: !controller.device.isRtl && isActive},
      {[styles.active_rtl_toggle]: controller.device.isRtl && isActive}
    )
  }

  return (
    <div {...containerProps}>
      <div {...buttonProps}>
        {label}
      </div>
    </div>
  )
});
